/* tslint:disable */
/* eslint-disable */
/**
 * Oasisscan API
 * https://github.com/bitcat365/oasisscan-backend#readme https://api.oasisscan.com/mainnet/swagger-ui/#/ https://api.oasisscan.com/mainnet/v2/api-docs 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DebondingDelegationRow,
    DebondingDelegationRowFromJSON,
    DebondingDelegationRowFromJSONTyped,
    DebondingDelegationRowToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse2006Data
 */
export interface InlineResponse2006Data {
    /**
     * 
     * @type {Array<DebondingDelegationRow>}
     * @memberof InlineResponse2006Data
     */
    list: Array<DebondingDelegationRow>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2006Data
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2006Data
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2006Data
     */
    maxPage: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2006Data
     */
    totalSize: number;
}

export function InlineResponse2006DataFromJSON(json: any): InlineResponse2006Data {
    return InlineResponse2006DataFromJSONTyped(json, false);
}

export function InlineResponse2006DataFromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse2006Data {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(DebondingDelegationRowFromJSON)),
        'page': json['page'],
        'size': json['size'],
        'maxPage': json['maxPage'],
        'totalSize': json['totalSize'],
    };
}

export function InlineResponse2006DataToJSON(value?: InlineResponse2006Data | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(DebondingDelegationRowToJSON)),
        'page': value.page,
        'size': value.size,
        'maxPage': value.maxPage,
        'totalSize': value.totalSize,
    };
}


